var map = {
	"./js/class/ThemePluginFilesBase.js": 44,
	"./js/class/ThemePluginFilesMigration.js": 86,
	"./js/class/ThemePluginFilesTransfer.js": 87,
	"./js/script.js": 88,
	"./sass/styles.scss": 90
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;


//////////////////
// WEBPACK FOOTER
// ./src/wp-migrate-db-pro-theme-plugin-files/asset/src ./node_modules/imports-loader?$=>window.jQuery ^(.*\.(js|sass|scss$))/i
// module id = 43
// module chunks = 0